enum MessageFailureStatus {
  undelivered = 'UNDELIVERED',
  error = 'ERROR',
  skipped = 'SKIPPED',
}

export default MessageFailureStatus;
